import React, { useState } from "react";
import { useQuery } from "react-apollo";
import { Container } from "reactstrap";
import { useTranslation } from "react-i18next";

import { errors } from "../../lib/translation/strings";

import { CatalogueItem } from "../../components/CatalogueItem/CatalogueItem";
import { HeadingTitle } from "../../components/shared/HeadingTitle/HeadingTitle";
import { LoadMoreButton } from "../../components/shared/LoadMoreButton/LoadMoreButton";

import {
  CatalogueProps,
  GET_CATALOGUE_POSTS
} from "../../queries/catalogueQueries";
import { LoadingPlaceholder } from "../../components/shared/LoadingPlaceholder/LoadingPlaceholder";

import "./Catalogue.scss";

export const Catalogue = () => {
  const postsLimit = 12;
  const { t } = useTranslation();
  const { loading, data, error, fetchMore } = useQuery(GET_CATALOGUE_POSTS, {
    variables: {
      limit: postsLimit,
      after: ""
    }
  });
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  if (loading) {
    return (
      <div className="Events my-5">
        <div className="d-flex justify-content-center align-content-center w-100">
          <LoadingPlaceholder />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="Events my-5">
        <Container>{t(errors.wentWrong)}</Container>
      </div>
    );
  }

  const events = data?.catalogues?.nodes;

  if (!events?.length || events?.length === 0) {
    return (
      <div className="Events my-5">
        <Container>{t(errors.nothingFound)}</Container>
      </div>
    );
  }

  const handleLoadMore = () => {
    setIsLoadingMore(true);

    fetchMore({
      variables: {
        limit: postsLimit,
        after: data.catalogues.pageInfo.endCursor
      },
      updateQuery: (previousResult: any, { fetchMoreResult }: any) => {
        const newNodes = fetchMoreResult.catalogues.nodes;
        const pageInfo = fetchMoreResult.catalogues.pageInfo;

        setIsLoadingMore(false);

        if (!newNodes.length) {
          return previousResult;
        }

        return {
          catalogues: {
            __typename: previousResult.catalogues.__typename,
            nodes: [...previousResult.catalogues.nodes, ...newNodes],
            pageInfo
          }
        };
      }
    });
  };

  return (
    <div className="Events my-5">
      <Container>
        <HeadingTitle title="Catalogue" />
        <div className="Events__list mt-2">
          {events.map((item: CatalogueProps) => {
            return (
              <CatalogueItem
                slug={item.slug}
                link={item.catalogueOptions.catalogue.mediaItemUrl}
                title={item.title}
                key={`${item.id}-catalogue-list`}
                image={item.featuredImage?.node?.sourceUrl}
              />
            );
          })}
        </div>
        {data?.catalogues.pageInfo.hasNextPage && (
          <LoadMoreButton
            onClick={() => handleLoadMore()}
            loading={loading || isLoadingMore}
          />
        )}
      </Container>
    </div>
  );
};
